<script setup lang="ts">
import BaseButton from '@/js/account/components/base/BaseButton.vue';
import BaseField from '@/js/account/components/base/BaseField.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

withDefaults(
  defineProps<{
    modelValue?: string
    label?: string
    name?: string
  }>(),
  {
    modelValue: '',
    label: 'Search',
    name: 'search',
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: string]
  'search': []
}>();

const cn = classNames('search-bar');

function onSearch(): void {
  emit('search');
}
</script>

<template>
  <div :class="cn()">
    <BaseField
      :label="label"
      :name="name"
      type="text"
      :model-value="modelValue"
      :class="cn('input')"
      @update:model-value="emit('update:modelValue', $event)"
      @keyup.enter="onSearch"
    />
    <BaseButton
      theme="primary"
      size="sm"
      aria-label="Search"
      :class="cn('button')"
      @click="onSearch"
    >
      <BaseIcon name="search" :width="24" :height="24" />
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  gap: 8px;

  &__input {
    flex-grow: 1;
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.2;
  }

  &__button {
    flex-shrink: 0;
    padding: 12px;
    max-width: 48px;
    max-height: 48px;
  }
}
</style>
